import { useValue } from '@morningtrain/react-resources'
import moment from 'moment'

function displayDuration (dur) {
  if (dur.asDays() >= 1) {
    return dur.humanize()
  }
  const s = dur.seconds().toString().padStart(2, '0')
  const m = dur.minutes().toString().padStart(2, '0')
  const h = dur.hours() + (Math.floor(dur.asDays()) * 24)
  return `${h}:${m}:${s}`
}

export default function PreciseDuration ({ name, defaultValue, unit }) {
  const value = useValue(name, defaultValue)
  if (!value) return null
  if (typeof value === 'string') return value
  const dur = moment.duration(value, unit)
  const durString = displayDuration(dur)
  return !dur ? null : durString
}
